import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { arrayOf, node, number, oneOf, oneOfType, string } from 'prop-types';
import { ALIGN_ITEMS } from "./constants";

var stringOrArrayOfStringsPropType = function stringOrArrayOfStringsPropType(constant) {
  var strings = Object.keys(constant);
  return oneOfType([oneOf(strings), arrayOf(oneOf(strings))]);
};

export var gridPropTypes = {
  alignItems: stringOrArrayOfStringsPropType(ALIGN_ITEMS),
  breakpoints: arrayOf(oneOfType([number, string])),
  children: node,
  columns: number,
  gutterWidth: oneOfType([number, string])
};
export var gridItemPropTypes = {
  span: oneOfType([number, arrayOf(number)])
};